import { Component, OnInit, Input, ViewChild, ElementRef, EventEmitter, Output, HostListener, AfterViewInit } from '@angular/core';
import { animate, transition, trigger, state, style, query, group } from '@angular/animations';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import * as en_stops from '../../tour/stops';
import * as es_stops from '../../tour/stops.es';
import { AnimationOptions } from 'ngx-lottie';

@Component({
  selector: 'app-info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.scss'],
  animations: [
    trigger("rewindAnimate", [
      state("true", style({ opacity: 1 })),
      state("false", style({ opacity: 0 })),
      transition("true => false", [
        // style({ opacity: 1 }),
        animate('1s ease', style({ opacity: 0 }))
      ]),
      // transition("false => true", [
      //   style({ opacity: 1 })
        // animate('.1s', style({ opacity: 1 }))
      // ])
    ])
  ]
})
export class InfoComponent implements OnInit, AfterViewInit {

  banner: any;

  constructor(private router: Router) {
    let isSpanish = router.url.slice(0, 4) == "/es" || router.url.slice(0, 4) == "/es/";
    if (isSpanish) {
      this.language = "es";
      this.infos = es_stops.INFOS;
      this.banner = es_stops.BANNER;
    } else {
      this.infos = en_stops.INFOS;
      this.banner = en_stops.BANNER;
    }
    if(router.url === '/the-barracks/info' || router.url === '/es/the-barracks/info'){
      this.subTitle = this.infos[0][1].subTitle
    }
  }

  @Input() stopNumber = 0;
  @Input() narration = "";
  @Input() info = [];
  @Input() audioHidden: boolean = false;
  @Input() language: string = "en";
  @Output() instruction = new EventEmitter<boolean>();
  @Output() changeState = new EventEmitter<boolean>();

  options: AnimationOptions = {
    path:'assets/globe-lottie.json'
  }

  @ViewChild('marquee')
  marquee: ElementRef;

  @ViewChild('audioContainer')
  audioContainer: ElementRef;
  welcomeBoxVisible = true;

  marqueeCheck: Subject<boolean> = new Subject();

  marqueeScroll: boolean = false;

  audioState: string = "stopped";
  playAudio: boolean = false;
  rewindAudio: number = 0;
  rewindAnimateToggle: boolean = false;
  playBtnAriaLabel: string = "";
  instructionOff: boolean = false;
  initScroll: boolean = false;
  infos: any;
  subTitle: any;

  intro_title: Array<string> = [
    "Welcome to the Sonoma Plaza",
    "The Bear Flag Monument",
    "Mission at Sonoma State Historic Park",
    "Blue Wing Inn",
    "Solomon Schocken",
    "Swiss Hotel with Hank Marioni",
    "Sonoma Plaza Saloons",
    "Chinese Sonoma",
    "The Duck Pond",
    "Bill Lynch"
  ]

  title_name: Array<string> = [
    "City Hall",
    "Bear Flag Mountain",
    "Blue Wing Inn",
    "Mission Solano",
    "The Barracks",
    "Swiss Hotel",
    "Eldorado Hotel"
  ]
  // intro_blerb: Array<string> = [
  //   "You may know the plaza as a place to shop, wine taste and dine, but the history has always been waiting to be told.",
  //   "This corner is clearly a historic place. Mission San Francisco Solano, founded in 1823, is in fact California Historical Landmark No.3.",
  //   "Where hospitality began on the Sonoma Plaza",
  //   "A story at the Barracks"
  // ]

  ngAfterViewInit(): void {
    this.initScroll = true;
  }


  ngOnInit(): void {
    if (this.language == "es") {
      this.intro_title = [
        "Bienvenido a la Plaza de Sonoma",
        "Monumento a la Bandera del Oso",
        "Misión en el Parque Histórico Est  atal de Sonoma",
        "Bienvenido al Blue Wing Inn",
        "Solomon Schocken",
        "Hotel suizo con Hank Marioni",
        "Los Bares de la Plaza de Sonoma",
        "El Sonoma Chino",
        "El Lago de Patos",
        "Bill Lynch"
      ]
    }
    this.marqueeCheck.subscribe(data => {
      // console.log(data);
      this.marqueeScroll = data;
    });
    this.playBtnAriaLabel = "Begin narration for " + this.intro_title[this.stopNumber];
    // console.log(this.info);
    // console.log(this.info);
  }

  play(value: boolean) {
    this.instructionOff = true;
    this.instruction.emit(false);
    this.playAudio = value;
    if (value == true) {
      this.audioState = "playing";
      this.playBtnAriaLabel = "Pause narration for " + this.intro_title[this.stopNumber];
      // console.log(this.marquee.nativeElement);
      setTimeout(() => {
        // console.log(this.marquee.nativeElement.offsetWidth);
        if (this.audioContainer.nativeElement.offsetWidth < (200+this.marquee.nativeElement.offsetWidth)) {
          this.marqueeCheck.next(true);
        } else {
          this.marqueeCheck.next(false);
        }
      }, 0)
    } else {
      this.audioState = "paused";
      this.playBtnAriaLabel = "Resume narration for " + this.intro_title[this.stopNumber];
    }
  }

  stopAudio() {
    this.audioState = "stopped";
    this.playAudio = false;
    this.playBtnAriaLabel = "Begin narration for " + this.intro_title[this.stopNumber];
  }

  rewind() {
    this.rewindAudio++;
    this.rewindAnimateToggle = true;
    setTimeout(() => {
      this.rewindAnimateToggle = false;
    }, 0);
  }

  nextStop() {
    this.changeState.emit(true);
  }

  openPage(url: string) {
    window.open(url, '_blank')
  }

  hideWelcomeBox() {
    this.welcomeBoxVisible = false;
  }
}
